// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".projects-widget .tooltip-style{background:#fff;border-radius:2px;box-shadow:0 1px 2px rgba(0,0,0,.15);padding:5px 8px}.projects-widget .percentage-text{font-size:smaller}", ""]);
// Exports
module.exports = exports;
